// pass url params through CTA buttons
export default function handleCTAClick(event, cta) {
  event.preventDefault();
  let ctaUrl = cta.link ?? '';

  const urlParams = new URLSearchParams(window?.location?.search);
  ctaUrl +=
    ctaUrl.indexOf('?') === -1
      ? `${urlParams.toString() ? `?${urlParams.toString()}` : ''}`
      : `${urlParams.toString() ? `&${urlParams.toString()}` : ''}`;

  window.location.assign(ctaUrl);
}
